module.exports = __webpack_public_path__ + "img/inner_2_bg.2070df8b.png";